<template>
  <v-dialog
    v-model="progressDialog"
    hide-overlay
    v-bind="modalPolicy.PERSISTENT_ONLY"
    :width="modalSpecial.PROGRESS_INLINE"
  >
    <v-card color="primary">
      <v-card-text>
        {{ $t('common.processingDoNotClose') }}
        <v-progress-linear
          indeterminate
          color="text"
          class="mb-0"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { MODAL_LAYOUT_SPECIAL, MODAL_CLOSE_POLICY } from '@/constants/modalLayout';

export default {
  name: 'ProgressDialog',
  data: () => ({
    modalSpecial: MODAL_LAYOUT_SPECIAL,
    modalPolicy: MODAL_CLOSE_POLICY,
    progressDialog: false
  }),
  mounted() {
    this.$eventBus.$on('request-data', this.onRequestDataEvent);
  },
  beforeUnmount() {
    this.$eventBus.$off('request-data', this.onRequestDataEvent);
  },
  methods: {
    onRequestDataEvent({ open }) {
      this.progressDialog = open;
    }
  }
};
</script>

<style scoped></style>
